import React, { useState } from "react";
import Button from "../../Components/Button";
import Modal from "../../Components/Modal/Modal";
import { ConnectionStatus } from "../../Interfaces/connections";
import {
  addSeperatorToInput,
  printPriceWithDecimalsForTableCell,
} from "../../helper";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ToggleSwitch from "../../Components/ToggleSwitch";
import { putRequest } from "../../Requests/requestTemplates";
import { Packet } from "../../Interfaces/commonDtos";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";
import Loading from "../../Components/Loading/Loading";
import tsetmcIcon from "src/Assets/Images/tsetmc.jpg";
import { Tooltip } from "@mui/material";

interface IProps {
  type: string | undefined;
  headerName: string;
  clonedRow: any;
  onAction?: () => void;
}

interface IAssignedSiteUser {
  id: number;
  name: string;
  userName: string;
}

export function unCapitalizeFirstLetter(input: string): string {
  return input.charAt(0).toLowerCase() + input.slice(1);
}

const Cell = ({ clonedRow, headerName, type, onAction }: IProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);

  const getStringListModalUI = (list: unknown[]) => {
    if (headerName === "MemberNames") {
      return (
        <div
          dir="rtl"
          className="min-w-[520px] max-w-[760px] max-h-[60vh] overflow-auto p-3 text-right"
        >
          <table className="w-full table-fixed border-collapse overflow-hidden rounded-md border border-slate-200 text-sm">
            <thead className="bg-slate-100 text-slate-700">
              <tr>
                <th className="w-16 border-b border-slate-200 px-3 py-2 text-center">
                  ردیف
                </th>
                <th className="border-b border-slate-200 px-4 py-2 text-right">
                  اکانت
                </th>
                <th className="border-b border-slate-200 px-4 py-2 text-right">
                  اکانت لینک‌شده
                </th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => {
                const displayItem = String(item);
                const [accountName, linkedAccountName = "—"] =
                  displayItem.split(/\r?\n/);

                return (
                  <tr
                    key={`${displayItem}-${index}`}
                    className="border-b border-slate-200 last:border-b-0 even:bg-slate-50"
                  >
                    <td className="px-3 py-3 text-center font-medium text-slate-700">
                      {index + 1}
                    </td>
                    <td className="px-4 py-3 font-medium text-slate-800">
                      {accountName}
                    </td>
                    <td className="px-4 py-3 font-medium text-slate-800">
                      {linkedAccountName}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }

    const isSahraUserGroupList =
      headerName === "AssignedSiteUsers";

    if (isSahraUserGroupList) {
      const siteUsers = list as IAssignedSiteUser[];

      return (
        <div
          dir="rtl"
          className="min-w-[520px] max-w-[760px] max-h-[60vh] overflow-auto p-3 text-right"
        >
          <table className="w-full table-fixed border-collapse overflow-hidden rounded-md border border-slate-200 text-sm">
            <thead className="bg-slate-100 text-slate-700">
              <tr>
                <th className="w-16 border-b border-slate-200 px-3 py-2 text-center">
                  ردیف
                </th>
                <th className="border-b border-slate-200 px-4 py-2 text-right">
                  نام
                </th>
                <th className="border-b border-slate-200 px-4 py-2 text-right">
                  نام کاربری
                </th>
              </tr>
            </thead>
            <tbody>
              {siteUsers.map((siteUser, index) => (
                  <tr
                    key={siteUser.id}
                    className="border-b border-slate-200 last:border-b-0 even:bg-slate-50"
                  >
                    <td className="px-3 py-3 text-center font-medium text-slate-700">
                      {index + 1}
                    </td>
                    <td className="px-4 py-3 font-medium text-slate-800">
                      {siteUser.name}
                    </td>
                    <td className="px-4 py-3 font-medium text-slate-800">
                      {siteUser.userName}
                    </td>
                  </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div className="flex flex-col justify-start items-start text-lg gap-4">
        {list.map((item, index) => (
          <div key={`${String(item)}-${index}`}>{String(item)}</div>
        ))}
      </div>
    );
  };

  const toggleSwitchChangeHandler = (v: any) => {
    setLoading(true);
    putRequest<any, Packet<boolean>>(v.putUrlCmd)
      .then((resp) => {
        if (resp.data) {
          // toast.success(resp.msg);
          if (onAction) onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const val = clonedRow[unCapitalizeFirstLetter(headerName)];
  const className =
    clonedRow[unCapitalizeFirstLetter(headerName) + "Classname"];

  if (
    typeof val === "number" &&
    val % 1 !== 0 &&
    type !== "Price" &&
    type !== "Decimal1"
  )
    return (
      <div dir="ltr" className={`w-full ${className ? className : ""}`}>
        {val.toFixed(2)}
      </div>
    );

  switch (type) {
    case "Decimal1":
      if (val == null)
        return <div className="w-full">ناموجود</div>;
      return (
        <div dir="ltr" className={`w-full ${className ? className : ""}`}>
          {Number(val).toFixed(1)}
        </div>
      );

    case "Price":
      if (val)
        return (
          <div className={`ltr w-full ${className ? className : ""}`}>
            {printPriceWithDecimalsForTableCell(val)}
          </div>
        );
      return <div className={`w-full ${className ? className : ""}`}>-</div>;

    case "Normal":
      if (val == null || val === "") return <div>-</div>;
      if (className?.includes("fund-priority-value")) {
        const [instrumentName, ...portfolioValueParts] = String(val).split("\n");
        return (
          <div dir="rtl" className="w-full">
            <div>{instrumentName}</div>
            <div dir="ltr" className="text-[10px] leading-4 text-slate-600">
              {portfolioValueParts.join("\n")}
            </div>
          </div>
        );
      }
      return (
        <div
          dir={String(val).includes("\n") ? "rtl" : String(val).includes("-") ? "ltr" : "rtl"}
          className={`w-full ${String(val).includes("\n") ? "whitespace-pre-line leading-tight" : ""} ${className ? className : ""}`}
        >
          {val}
        </div>
      );
    case "Ltr":
      return (
        <div className={`w-full ltr ${className ? className : ""}`}>{val}</div>
      );

    case "Boolean":
      if (val)
        return (
          <CheckIcon
            className={`w-full ${className ? className : ""}`}
            color="success"
            fontSize="small"
          />
        );
      return (
        <CloseIcon
          className={`w-full ${className ? className : ""}`}
          color="error"
          fontSize="small"
        />
      );

    case "Link":
      return (
        <a
          href={val}
          className={`urderline w-full text-blue-400 hover:text-blue-800 ${
            className ? className : ""
          }`}
          target="_blank"
        >
          URL
        </a>
      );

    case "IconLink": {
      const linkValue = val as { text?: string; href?: string; icon?: string; title?: string } | null;
      if (!linkValue) return <div>-</div>;
      const iconSource = linkValue.icon === "tsetmc" ? tsetmcIcon : linkValue.icon;
      return (
        <div className="flex w-full items-center justify-center gap-1" dir="rtl">
          <span>{linkValue.text || "-"}</span>
          {linkValue.href && iconSource ? (
            <a
              href={linkValue.href}
              target="_blank"
              rel="noopener noreferrer"
              title={linkValue.title || "نمایش لینک"}
              onClick={(event) => event.stopPropagation()}
              className="inline-flex h-4 w-4 shrink-0 items-center justify-center"
            >
              <img src={iconSource} alt="لینک" className="h-3 w-3 rounded-full" />
            </a>
          ) : null}
        </div>
      );
    }

    case "ProgressBar": {
      const progressValue = val as { value?: number; total?: number; text?: string } | null;
      const value = Number(progressValue?.value || 0);
      const total = Number(progressValue?.total || 0);
      const percent = total > 0 ? Math.min(100, Math.max(0, value * 100 / total)) : 0;
      const text = progressValue?.text || value.toLocaleString();
      return (
        <div className="w-full px-0.5" title={`${value.toLocaleString()} از ${total.toLocaleString()} (${percent.toFixed(0)}%)`}>
          <div className="mb-0.5 text-center text-xs">{text}</div>
          <div className="h-1 overflow-hidden rounded bg-gray-200">
            <div className="h-full bg-sky-600" style={{ width: `${percent}%` }} />
          </div>
        </div>
      );
    }

    case "HoverTable": {
      const hoverValue = val as { text?: string; headers?: string[]; rows?: string[][] } | null;
      if (!hoverValue) return <div>-</div>;
      const content = <div className="max-h-80 w-max max-w-[760px] overflow-auto p-1" dir="rtl">
        <table className="border-collapse whitespace-nowrap text-xs text-white">
          {hoverValue.headers?.length ? <thead><tr>{hoverValue.headers.map((header, index) => <th key={`${header}-${index}`} className="border border-slate-500 bg-slate-700 px-2 py-1 font-semibold">{header}</th>)}</tr></thead> : null}
          <tbody>{hoverValue.rows?.map((cells, rowIndex) => <tr key={rowIndex}>{cells.map((cell, cellIndex) => <td key={cellIndex} dir={cell.includes("-") ? "ltr" : undefined} className="border border-slate-500 px-2 py-1 text-center">{cell || "-"}</td>)}</tr>)}</tbody>
        </table>
      </div>;
      if (!hoverValue.rows?.length) return <div className={`w-full ${className || ""}`}>{hoverValue.text || "-"}</div>;
      return <Tooltip title={content} arrow placement="top" componentsProps={{ tooltip: { sx: { maxWidth: "none" } } }}>
        <div className={`w-full cursor-help whitespace-nowrap [unicode-bidi:isolate] ${className || ""}`} dir={hoverValue.text?.includes("=>") ? "ltr" : "rtl"}>{hoverValue.text || "-"}</div>
      </Tooltip>;
    }

    case "Status":
      if (val === ConnectionStatus.Online)
        return (
          <div
            className={`w-3 h-3  rounded-full bg-green-600 m-auto ${
              className ? className : ""
            }`}
          />
        );
      if (val === ConnectionStatus.Disconnected)
        return (
          <div
            className={`w-3 h-3 rounded-full bg-red-700 m-auto ${
              className ? className : ""
            }`}
          />
        );
      if (val === ConnectionStatus.Offline)
        return (
          <div
            className={`w-3 h-3 rounded-full bg-gray-300 m-auto ${
              className ? className : ""
            }`}
          />
        );
      return <>-</>;

    case "Image":
      if (val)
        return (
          <div className={`w-16 h-6 mb-px ${className ? className : ""}`}>
            <img src={`/v1/captcha/${val}`} />
          </div>
        );
      return <>-</>;

    case "StringList":
      if (val && val.length) {
        if (headerName === "SahraUserGroupNames")
          return (
            <div dir="rtl" className="w-full text-right">
              {val.map(String).join("، ")}
            </div>
          );

        return (
          <>
            {isModalOpen ? (
              <Modal title="مشاهده"
                UI={getStringListModalUI(val)}
                onClose={() => setIsModalOpen(false)}
              />
            ) : null}
            <Button
              className="table-btn"
              text="مشاهده"
              variant="contained"
              onClick={() => setIsModalOpen(true)}
            />
          </>
        );
      }
      return <></>;

    case "ToggleSwitch":
      return (
        <>
          {loading ? (
            <Loading />
          ) : (
            <ToggleSwitch
              checked={val.value}
              label=""
              name=""
              onChange={() => toggleSwitchChangeHandler(val)}
            />
          )}
        </>
      );

    default: {
      if (val)
        return (
          <div className={`w-full ${className ? className : ""}`}>{val}</div>
        );
      return <b>-</b>;
    }
  }
};

export default Cell;
